import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import { Box, Button, Typography } from "@mui/material"
import { styled } from "@mui/system"
import useAuthRedirect from "hooks/useAuthRedirect"
import { api } from "lib/api"
import openWindowAsync from "lib/open-window-async"
import ConventionSession from "models/convention-api/v1/ConventionSession"
import SessionAttachment from "models/convention-api/v1/SessionAttachment"
import React from "react"

interface SessionAdditionalResourcesProps {
  className?: string
  session: ConventionSession
}

const SessionAdditionalResources = (props: SessionAdditionalResourcesProps) => {
  const { session, className } = props
  const authRedirect = useAuthRedirect()

  const openAttachment = (attachment: SessionAttachment) => () => {
    authRedirect(() =>
      openWindowAsync(async () => {
        await api.createSessionAttachmentView({ req: undefined }, attachment.id)
        return attachment.url || ""
      }),
    )
  }

  return (
    <_Container className={className}>
      <_Title component="h5">Additional Resources</_Title>
      <_List>
        {session.attachments?.map((attachment) => (
          <_ListItem key={attachment.id}>
            <_Attachment onClick={openAttachment(attachment)} endIcon={<OpenInNewIcon />}>
              {attachment.caption}
            </_Attachment>
          </_ListItem>
        ))}
      </_List>
    </_Container>
  )
}

export default SessionAdditionalResources

const _Container = styled(Box)({}) as typeof Box
const _Title = styled(Typography)(({ theme }) => ({
  ...theme.fonts.raleway700,
  fontSize: "16px",
  lineHeight: "19px",
  margin: "0 0 18px 0",
})) as typeof Typography

const _List = styled("ul")({
  display: "flex",
  flexFlow: "column nowrap",
  alignItems: "stretch",
  justifyContent: "stretch",
  gap: "15px",
  listStyleType: "none",
  padding: 0,
})
const _ListItem = styled("li")({
  marginLeft: "-8px",
})
const _Attachment = styled(Button)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  textTransform: "initial",
  textAlign: "start",
  fontSize: "16px",
  color: theme.palette.gray.darkest,
  ".MuiButton-endIcon": {
    marginLeft: "23px",
  },
}))
